
document.addEventListener('DOMContentLoaded', () => {
  if (typeof window.Swiper === 'undefined') return;

  const greendaleUpcomingSections = document.querySelectorAll('[data-greendale-upcoming-events-split]');

  greendaleUpcomingSections.forEach((greendaleUpcomingSection) => {
    const greendaleMedia = greendaleUpcomingSection.querySelector('[data-greendale-upcoming-swiper]');
    const greendaleTrack = greendaleUpcomingSection.querySelector('[data-greendale-upcoming-track]');
    if (!greendaleMedia || !greendaleTrack) return;

    const greendaleEnableSlider = window.matchMedia('(max-width: 989px)').matches;
    if (!greendaleEnableSlider) return;

    if (greendaleTrack.classList.contains('swiper-initialized')) return;

    greendaleTrack.classList.add('swiper');
    const greendaleWrapper = document.createElement('div');
    greendaleWrapper.className = 'swiper-wrapper';

    Array.from(greendaleTrack.children).forEach((greendaleSlide) => {
      greendaleSlide.classList.add('swiper-slide');
      greendaleWrapper.appendChild(greendaleSlide);
    });

    greendaleTrack.appendChild(greendaleWrapper);

    const greendaleUpcomingSlider = new window.Swiper(greendaleTrack, {
      slidesPerView: 1,
      spaceBetween: 8,
      speed: 500,
      breakpoints: {
        640: { slidesPerView: 1, spaceBetween: 10 },
        820: { slidesPerView: 2, spaceBetween: 10 }
      },
      pagination: {
        el: greendaleMedia.querySelector('[data-greendale-upcoming-pagination]'),
        clickable: true,
      },
    });

    void greendaleUpcomingSlider;
  });
});

document.addEventListener('DOMContentLoaded', () => {
  if (typeof window.Swiper === 'undefined') return;

  const greendaleSliderImageSections = document.querySelectorAll('[data-greendale-slider-image-split]');

  greendaleSliderImageSections.forEach((greendaleSection) => {
  const greendaleTrack = greendaleSection.querySelector('[data-greendale-slider-image-track]');
  if (!greendaleTrack || greendaleTrack.classList.contains('swiper-initialized')) return;

  const greendaleSlides = Array.from(greendaleTrack.children);

  // Read attributes
  const greendaleAutoplay =
    greendaleSection.getAttribute('data-autoplay') === 'true';

  const greendaleAutoplaySpeed =
    parseInt(greendaleSection.getAttribute('data-autoplay-speed'), 10) || 5;

  greendaleTrack.classList.add('swiper');

  const greendaleWrapper = document.createElement('div');
  greendaleWrapper.className = 'swiper-wrapper';

  greendaleSlides.forEach((greendaleSlide) => {
    greendaleSlide.classList.add('swiper-slide');
    greendaleWrapper.appendChild(greendaleSlide);
  });

  greendaleTrack.appendChild(greendaleWrapper);

  const greendalePrev = greendaleSection.querySelector(
    '.greendale-slider-image-split__nav--prev'
  );

  const greendaleNext = greendaleSection.querySelector(
    '.greendale-slider-image-split__nav--next'
  );

  const greendaleSlider = new window.Swiper(greendaleTrack, {
    slidesPerView: 1,
    spaceBetween: 0,
    speed: 500, // transition speed between slides
    loop: greendaleSlides.length > 1,

    autoplay: greendaleAutoplay
      ? {
          delay: greendaleAutoplaySpeed * 1000, // convert seconds to ms
          disableOnInteraction: false
        }
      : false,

    navigation: {
      prevEl: greendalePrev,
      nextEl: greendaleNext
    }
  });
  void greendaleSlider;
});
});

document.addEventListener('DOMContentLoaded', () => {
  const greendaleEventSections = document.querySelectorAll('[data-greendale-event-calendar]');
  const greendaleWeekdays = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];

  greendaleEventSections.forEach((greendaleSection) => {
    const greendaleOpenButtons = greendaleSection.querySelectorAll('[data-greendale-event-open]');
    const greendaleModals = greendaleSection.querySelectorAll('[data-greendale-event-modal]');
    const greendaleMonthLabel = greendaleSection.querySelector('[data-greendale-calendar-month-label]');
    const greendaleGrid = greendaleSection.querySelector('[data-greendale-calendar-grid]');
    const greendalePrevButton = greendaleSection.querySelector('[data-greendale-calendar-prev]');
    const greendaleNextButton = greendaleSection.querySelector('[data-greendale-calendar-next]');
    const greendaleEventItems = Array.from(greendaleSection.querySelectorAll('[data-greendale-event-item]'));
    const greendaleMonths = [];
    const greendaleMonthMap = new Map();
    let greendaleCurrentMonthIndex = 0;

    const greendaleToDate = (greendaleValue) => {
      if (!greendaleValue) return null;
      const greendaleDate = new Date(`${greendaleValue}T00:00:00`);
      return Number.isNaN(greendaleDate.getTime()) ? null : greendaleDate;
    };

    greendaleEventItems.forEach((greendaleItem) => {
      const greendaleDate = greendaleToDate(greendaleItem.getAttribute('data-event-date'));
      if (!greendaleDate) return;

      const greendaleMonthKey = `${greendaleDate.getFullYear()}-${String(greendaleDate.getMonth() + 1).padStart(2, '0')}`;
      if (!greendaleMonthMap.has(greendaleMonthKey)) {
        const greendaleMonthData = {
          key: greendaleMonthKey,
          year: greendaleDate.getFullYear(),
          monthIndex: greendaleDate.getMonth(),
          events: []
        };
        greendaleMonthMap.set(greendaleMonthKey, greendaleMonthData);
        greendaleMonths.push(greendaleMonthData);
      }

      greendaleMonthMap.get(greendaleMonthKey).events.push({
        id: greendaleItem.getAttribute('data-event-id'),
        day: greendaleDate.getDate(),
        badge: greendaleItem.getAttribute('data-event-badge') || greendaleItem.getAttribute('data-event-title') || ''
      });
    });

    greendaleMonths.sort((greendaleA, greendaleB) => {
      const greendaleAValue = new Date(greendaleA.year, greendaleA.monthIndex, 1).getTime();
      const greendaleBValue = new Date(greendaleB.year, greendaleB.monthIndex, 1).getTime();
      return greendaleAValue - greendaleBValue;
    });

    const greendaleRenderMonth = () => {
      if (!greendaleGrid || !greendaleMonthLabel) return;

      if (!greendaleMonths.length) {
        greendaleMonthLabel.textContent = greendaleMonthLabel.textContent || 'EVENTS';
        greendaleGrid.innerHTML = '';
        if (greendalePrevButton) greendalePrevButton.disabled = true;
        if (greendaleNextButton) greendaleNextButton.disabled = true;
        return;
      }

      const greendaleMonth = greendaleMonths[greendaleCurrentMonthIndex];
      const greendaleFirstDay = new Date(greendaleMonth.year, greendaleMonth.monthIndex, 1);
      const greendaleDaysInMonth = new Date(greendaleMonth.year, greendaleMonth.monthIndex + 1, 0).getDate();
      const greendaleStartWeekday = greendaleFirstDay.getDay();
      const greendaleLabel = greendaleFirstDay.toLocaleString('en-US', { month: 'short', year: 'numeric' }).replace(' ', '. ').toUpperCase();

      greendaleMonthLabel.textContent = greendaleLabel;
      if (greendalePrevButton) greendalePrevButton.disabled = greendaleCurrentMonthIndex === 0;
      if (greendaleNextButton) greendaleNextButton.disabled = greendaleCurrentMonthIndex === greendaleMonths.length - 1;

      let greendaleMarkup = '';
      greendaleWeekdays.forEach((greendaleWeekday) => {
        greendaleMarkup += `<div class="greendale-event-calendar__weekday">${greendaleWeekday}</div>`;
      });

      for (let greendaleIndex = 0; greendaleIndex < 42; greendaleIndex += 1) {
        const greendaleDay = greendaleIndex - greendaleStartWeekday + 1;
        const greendaleInMonth = greendaleDay > 0 && greendaleDay <= greendaleDaysInMonth;

        if (!greendaleInMonth) {
          greendaleMarkup += '<div class="greendale-event-calendar__cell greendale-event-calendar__cell--empty"><span class="greendale-event-calendar__empty-mark">-</span></div>';
          continue;
        }

        const greendaleDayEvents = greendaleMonth.events.filter((greendaleEvent) => greendaleEvent.day === greendaleDay);
        let greendaleBadgesMarkup = '';
        greendaleDayEvents.forEach((greendaleEvent) => {
          greendaleBadgesMarkup += `<button class="greendale-event-calendar__badge" type="button" data-greendale-event-open="${greendaleEvent.id}" aria-label="Open event ${greendaleEvent.badge.replace(/"/g, '&quot;')}">${greendaleEvent.badge}</button>`;
        });

        greendaleMarkup += `
          <div class="greendale-event-calendar__cell">
            <div class="greendale-event-calendar__day-number">${greendaleDay}</div>
            <div class="greendale-event-calendar__badges">${greendaleBadgesMarkup}</div>
          </div>
        `;
      }

      greendaleGrid.innerHTML = `<div class="greendale-event-calendar__table">${greendaleMarkup}</div>`;
      greendaleGrid.querySelectorAll('[data-greendale-event-open]').forEach((greendaleButton) => {
        greendaleButton.addEventListener('click', () => {
          const greendaleTarget = greendaleButton.getAttribute('data-greendale-event-open');
          const greendaleModal = greendaleSection.querySelector(`[data-greendale-event-modal="${greendaleTarget}"]`);
          if (!greendaleModal) return;

          greendaleCloseAll();
          greendaleModal.hidden = false;
          requestAnimationFrame(() => greendaleModal.classList.add('is-visible'));
          document.body.classList.add('greendale-event-modal-open');
        });
      });
    };

    const greendaleCloseAll = () => {
      greendaleModals.forEach((greendaleModal) => {
        greendaleModal.hidden = true;
        greendaleModal.classList.remove('is-visible');
      });
      document.body.classList.remove('greendale-event-modal-open');
    };

    greendaleOpenButtons.forEach((greendaleButton) => {
      greendaleButton.addEventListener('click', () => {
        const greendaleTarget = greendaleButton.getAttribute('data-greendale-event-open');
        const greendaleModal = greendaleSection.querySelector(`[data-greendale-event-modal="${greendaleTarget}"]`);
        if (!greendaleModal) return;

        greendaleCloseAll();
        greendaleModal.hidden = false;
        requestAnimationFrame(() => greendaleModal.classList.add('is-visible'));
        document.body.classList.add('greendale-event-modal-open');
      });
    });

    greendaleSection.querySelectorAll('[data-greendale-event-close]').forEach((greendaleCloseButton) => {
      greendaleCloseButton.addEventListener('click', greendaleCloseAll);
    });

    greendaleSection.querySelectorAll('[data-greendale-event-more]').forEach((greendaleMoreButton) => {
      greendaleMoreButton.addEventListener('click', () => {
        const greendaleSectionBody = greendaleMoreButton.closest('.greendale-event-modal__section');
        const greendaleDetails = greendaleSectionBody?.querySelector('[data-greendale-event-details]');
        if (!greendaleDetails) return;

        const greendaleIsHidden = greendaleDetails.hasAttribute('hidden');
        if (greendaleIsHidden) {
          greendaleDetails.removeAttribute('hidden');
          greendaleMoreButton.textContent = 'Less';
        } else {
          greendaleDetails.setAttribute('hidden', '');
          greendaleMoreButton.textContent = 'More';
        }
      });
    });

    if (greendalePrevButton) {
      greendalePrevButton.addEventListener('click', () => {
        if (greendaleCurrentMonthIndex <= 0) return;
        greendaleCurrentMonthIndex -= 1;
        greendaleRenderMonth();
      });
    }

    if (greendaleNextButton) {
      greendaleNextButton.addEventListener('click', () => {
        if (greendaleCurrentMonthIndex >= greendaleMonths.length - 1) return;
        greendaleCurrentMonthIndex += 1;
        greendaleRenderMonth();
      });
    }

    greendaleRenderMonth();
  });

  document.addEventListener('keydown', (greendaleEvent) => {
    if (greendaleEvent.key !== 'Escape') return;

    document.querySelectorAll('[data-greendale-event-modal].is-visible').forEach((greendaleModal) => {
      greendaleModal.hidden = true;
      greendaleModal.classList.remove('is-visible');
    });
    document.body.classList.remove('greendale-event-modal-open');
  });
  document.addEventListener('click', function(e) {
  const btn = e.target.closest('.greendale-apple-calendar');

  if (!btn) return;

  e.preventDefault();

  const content = decodeURIComponent(
  btn.dataset.calendar.replace(/\+/g, ' ')
);

  const blob = new Blob([content], {
    type: 'text/calendar;charset=utf-8'
  });

  const url = URL.createObjectURL(blob);

  const a = document.createElement('a');

  a.href = url;
  a.download = btn.dataset.file;

  document.body.appendChild(a);

  a.click();

  document.body.removeChild(a);

  URL.revokeObjectURL(url);
});
});